export const FETCH_NOTIFICATION_CONFIGS = 'FETCH_NOTIFICATION_CONFIGS'
export const UPDATE_NOTIFICATION_CONFIG = 'UPDATE_NOTIFICATION_CONFIG'
export const SET_NOTIFICATION_CONFIGS = 'SET_NOTIFICATION_CONFIGS'
export const UPDATE_EDIT_LIST = 'UPDATE_EDIT_LIST'
export const UPDATE_EDIT_MODE = 'UPDATE_EDIT_MODE'
export const SET_ADMIN_LIST = 'SET_ADMIN_LIST'
export const DELETE_EDIT_LIST = 'DELETE_EDIT_LIST'